var _style, _polygon, _polygon2, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _path14, _path15, _circle2, _path16, _path17, _circle3, _path18, _path19, _circle4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileDetailsF8B7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ed709b15-984e-4c6b-b13e-799af1de279c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 829.7 548.9",
    style: {
      enableBackground: "new 0 0 829.7 548.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFB8B8;}\n\t.st1{fill:#2F2E41;}\n\t.st2{fill:#3F3D56;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#E6E6E6;}\n\t.st6{fill:url(#SVGID_00000018214153880203430530000017172667536692573569_);}\n\t.st7{fill:#6C63FF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "609.4,522.9 591.6,522.9 591.6,349.5 632.1,348.7 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "695.3,522.9 713.1,522.9 713.1,349.5 672.6,348.7 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M601,547l-37.9-0.3c-6.6,1.6-13.3-2.4-14.9-9c-0.2-1-0.4-2-0.4-3l0,0c0-4.7,2.7-9.1,7-11.1l8.7-4.2l28.1-19.2 l20.3,5.7l3.9,17.5C618.1,533.9,611.5,544.4,601,547z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M703.1,546.8l-37.9-0.3c-6.6,1.6-13.3-2.4-14.9-9c-0.2-1-0.4-2-0.4-3l0,0c0-4.7,2.7-9.1,7-11.1l8.7-4.2 l28.1-19.2l20.3,5.7l3.9,17.5C720.1,533.7,713.6,544.2,703.1,546.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M717.9,377.9l-55.8-5l-7.4-65.5l-16.5,63.4l-56.5-5c2.1-38.8,6.6-71.2,17-87.5l118.3-21.1L717.9,377.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 661.5,
    cy: 44.4,
    r: 30.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M685.5,107.3l-52.7-6.5c6.7-14.3,9.7-27.6,4.9-38.9h40.5C672,73.2,677.6,89.7,685.5,107.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M717.1,258.9c-37.1,27.2-77.5,36.4-121.5,26.7c26.7-61,22.9-121.1,0-180.7l42.1-17.8 c11.8,11.5,25.4,11.8,40.5,1.6l41.3,8.9C712,157,709.5,212.2,717.1,258.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M639.2,18.1l-5.1-2c0,0,10.7-11.7,25.5-10.7l-4.2-4.6c0,0,10.2-4.1,19.5,6.6c4.9,5.6,10.5,12.2,14,19.7h5.5 l-2.3,5l8,5l-8.2-0.9c0.8,4.3,0.5,8.8-0.8,13l0.2,4c0,0-9.5-14.7-9.5-16.7v5.1c0,0-5.1-4.6-5.1-7.6l-2.8,3.6l-1.4-5.6l-17.1,5.6 l2.8-4.6l-10.7,1.5l4.2-5.6c0,0-12,6.6-12.5,12.2s-6.5,12.7-6.5,12.7l-2.8-5.1C630,48.7,625.8,25.7,639.2,18.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 534.5207,
    y1: 302,
    x2: 731.5207,
    y2: 302
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M724.5,323h-183c-3.9,0-7-3.1-7-7v-28c0-3.9,3.1-7,7-7h183c3.9,0,7,3.1,7,7v28C731.5,319.9,728.4,323,724.5,323 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "e6024a0c-b89c-4e07-9a96-496d93fbcaea",
    className: "st4",
    d: "M568.9,296.1c-3.3,0.1-5.9,2.8-5.8,6c0.1,3.2,2.6,5.8,5.8,5.8H697 c3.3,0,6-2.6,6-5.9c0-3.3-2.6-6-5.8-6c-0.1,0-0.1,0-0.2,0H568.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M614.2,274.2l9.3,16.6c4,7.1,1.5,16.1-5.6,20c-1.1,0.6-2.3,1.1-3.5,1.4l0,0c-7.9,2.1-15.9-2.7-18-10.5 c-0.3-1.3-0.5-2.7-0.5-4l0.4-22.7c-7-40.3-12.7-78.5-11.3-105.3h32.4l-6.5,30.8L614.2,274.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M721.2,278.3l-6.8,11.4c-3.7,6.2-11.8,8.2-18,4.5c-1.5-0.9-2.8-2.1-3.9-3.5l0,0c-4.3-5.9-3-14.1,2.9-18.3 c0,0,0.1,0,0.1-0.1l11.9-8.5l17-70.5l-10.5-29.2l29.2-4.9C756.8,190.8,743,233,721.2,278.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M624.8,176.2l-42.9-2.4l3-46c-0.3-13.4,8.6-25.3,21.6-28.7l5.4-1.4L624.8,176.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M746.3,161.6l-39.7,9.7V95.2l1.6-0.1c13.5-0.9,25.6,8.3,28.4,21.5L746.3,161.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 223.6,
    y: 546.9,
    className: "st5",
    width: 606.1,
    height: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26.6,487.8c0.5,20.3,3.9,40.4,10.1,59.7c0.1,0.4,0.3,0.9,0.4,1.3h37.6c0-0.4-0.1-0.8-0.1-1.3 c-2.5-28.8-17-204.4,0.3-234.5C73.5,315.5,23.7,396.2,26.6,487.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.5,547.5c0.3,0.4,0.6,0.9,1,1.3h28.2c-0.2-0.4-0.5-0.8-0.7-1.3c-4.7-8.4-18.5-33.6-31.3-59.7 c-13.8-28-26.4-57.1-25.3-67.7C1,422.5-8.6,495,29.5,547.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075876929798090670930000014774831372598740874_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.8828,
    y1: 131.8189,
    x2: 388.8828,
    y2: 131.8189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09189361,
    style: {
      stopColor: "#F7941D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5948,
    style: {
      stopColor: "#F15A29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075876929798090670930000014774831372598740874_)"
    },
    d: "M381.9,224.3h-307c-3.9,0-7-3.1-7-7v-171 c0-3.9,3.1-7,7-7h307c3.9,0,7,3.1,7,7v171C388.9,221.2,385.7,224.3,381.9,224.3z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M385.7,548.9h-315c-2.8,0-5-2.2-5-5v-500c0-2.8,2.2-5,5-5h315c2.8,0,5,2.2,5,5v500 C390.7,546.6,388.4,548.9,385.7,548.9z M70.7,40.9c-1.7,0-3,1.3-3,3v500c0,1.7,1.3,3,3,3h315c1.7,0,3-1.3,3-3v-500c0-1.7-1.3-3-3-3 H70.7z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 107.9,
    cy: 306.3,
    r: 11
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.9,327.3h-183c-3.9,0-7-3.1-7-7v-28c0-3.9,3.1-7,7-7h183c3.9,0,7,3.1,7,7v28 C346.9,324.2,343.7,327.3,339.9,327.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M346.9,328.3h-197c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h197c0.6,0,1,0.4,1,1C347.9,327.9,347.4,328.3,346.9,328.3z "
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 107.9,
    cy: 372.3,
    r: 11
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.9,393.3h-183c-3.9,0-7-3.1-7-7v-28c0-3.9,3.1-7,7-7h183c3.9,0,7,3.1,7,7v28 C346.9,390.2,343.7,393.3,339.9,393.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M346.9,394.3h-197c-0.6,0-1-0.4-1-1s0.4-1,1-1h197c0.6,0,1,0.4,1,1S347.4,394.3,346.9,394.3z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 107.9,
    cy: 438.3,
    r: 11
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.9,459.3h-76c-3.9,0-7-3.1-7-7v-28c0-3.9,3.1-7,7-7h76c3.9,0,7,3.1,7,7v28 C239.9,456.2,236.7,459.3,232.9,459.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.9,460.3h-90c-0.6,0-1-0.4-1-1s0.4-1,1-1h90c0.6,0,1,0.4,1,1S240.4,460.3,239.9,460.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.9,459.3h-76c-3.9,0-7-3.1-7-7v-28c0-3.9,3.1-7,7-7h76c3.9,0,7,3.1,7,7v28 C346.9,456.2,343.7,459.3,339.9,459.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M346.9,460.3h-90c-0.6,0-1-0.4-1-1s0.4-1,1-1h90c0.6,0,1,0.4,1,1S347.4,460.3,346.9,460.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "aa22f97a-b0c4-48a0-9697-8e710bb4cd75",
    className: "st4",
    d: "M108.2,92.9c-3.3,0.1-5.9,2.8-5.8,6c0.1,3.2,2.6,5.8,5.8,5.8h240.1 c3.3,0.1,6-2.6,6-5.8c0.1-3.3-2.6-6-5.8-6c-0.1,0-0.1,0-0.2,0H108.2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "a17c1cae-a14a-457b-86dc-2629628de1d6",
    className: "st4",
    d: "M108.2,125.9c-3.3,0.1-5.9,2.8-5.8,6c0.1,3.2,2.6,5.8,5.8,5.8h240.1 c3.3,0.1,6-2.6,6-5.8c0.1-3.3-2.6-6-5.8-6l0,0c-0.1,0-0.1,0-0.2,0H108.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "b5ca973b-c484-402e-90b9-a33cbeee2455",
    className: "st4",
    d: "M108.2,158.9c-3.3,0.1-5.9,2.8-5.8,6c0.1,3.2,2.6,5.8,5.8,5.8h240.1 c3.3,0.1,6-2.6,6-5.8c0.1-3.3-2.6-6-5.8-6c-0.1,0-0.1,0-0.2,0H108.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M337.7,508.6l-2.5-2.5c-0.1-0.1-0.3-0.2-0.4-0.2h-1.2c-0.3,0-0.6,0.3-0.6,0.6c0,0.2,0.1,0.3,0.2,0.4l1.4,1.4 h-11.1c-0.6,0-1,0.4-1,1s0.4,1,1,1h11.1l-1.3,1.3c-0.3,0.3-0.3,0.7,0,0.9c0.1,0.1,0.3,0.2,0.5,0.2h1c0.2,0,0.3-0.1,0.5-0.2l2.5-2.5 C338.1,509.6,338.1,509,337.7,508.6L337.7,508.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M330.9,525.3c-8.8,0-16-7.2-16-16s7.2-16,16-16s16,7.2,16,16C346.9,518.2,339.7,525.3,330.9,525.3z  M330.9,495.3c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14C344.9,501.6,338.6,495.3,330.9,495.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDetailsF8B7);
export default __webpack_public_path__ + "static/media/profile_details_f8b7.9f6ffe2641b2fa0b6d194e765619fcc9.svg";
export { ForwardRef as ReactComponent };